import { ButtonLoader } from "./form";
import { useDispatch } from "react-redux";

import * as settingsAction from "store/entities/settingsInfo/action";
import useLoginInfo from 'hooks/useLoginInfo';
import Maybe from "./Maybe";
import {ReactComponent as Lock} from "assets/images/icons/lock.svg";
import {ReactComponent as Caution} from "assets/images/icons/orange-caution.svg";


const TwoFactorAuthConsent = (props) => {
    const {setIsOpen2fa, switchModalContent} = props;
    const dispatch = useDispatch();
    const {userInfo} = useLoginInfo();
    
    
    const handleSendOtp = () => { 
            dispatch(settingsAction.sendTransactionPinOtp(userInfo?.token, 'two-fa'))
            // dispatch(settingsAction.sendTransactionPinOtp(userInfo?.token, {userId: userInfo?.employer?._id, purpose: 'access-pin'}))
            switchModalContent()
    }
    

    return (
        <>
        
        <div className="w-[138px] h-[138px] mx-auto">
                            <Lock className="mx-auto" />
                        </div>
                        

                            <div className="mt-2 relative top-6">
                                {props.subText}
                            </div>
                        
                            <div className="mt-6 mb-4 relative top-6 bg-ep-banner py-3 px-4 rounded-[8px] flex items-center">
                                <Caution className="w-[13.33px] h-[13.33px] mr-2" alt="caution" />
                                <span className="flex-1 text-sm">{props.cautionText}</span>
                            </div>
                        <Maybe condition={props.footnote !== undefined}>
                            <div className="mt-2 relative top-6">
                                {props.footnote}
                            </div>
                        </Maybe>

                        <div className="mt-10 flex space-x-4 justify-end">
                            <button type="button" onClick={() => {setIsOpen2fa(false); props.handleCancel && props.handleCancel()}} className="btn btn-transparent-primary">
                                Cancel
                            </button>
                            <ButtonLoader loading={props.loading} onClick={handleSendOtp} className="btn btn-ep-primary">
                                Continue
                            </ButtonLoader>
                        </div>
        </>
    )
}

export default TwoFactorAuthConsent;
